module.exports = __webpack_public_path__ + "img/dev.a47c045b.jpeg";